import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const FornecedorSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Criar',
            icon: 'pi pi-plus',
            command: () => onOptionChange('criar')
        },
        {
            label: 'Consultar',
            icon: 'pi pi-search',
            command: () => onOptionChange('consultar')
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default FornecedorSidebar;
